import { ProductCopyDetails } from '../../../store/api';
import { collectionConfig } from '../../../config';
import { http } from '../../../api/axios';

export const getIssueCopies = async (productId: string) => {
    const { data } = await http.get<ProductCopyDetails[]>(collectionConfig().endpointIssueCopyDetails, {
        pathParams: { productId }
    });
    return data;
};
